import { createFilterUpdater } from './helpers';

export const tableReducers = {
    updateDashboardTable: createFilterUpdater('dashContact'),
    updateNoTaskTable: createFilterUpdater('noTaskTableData'),
    updateAlignerTable: createFilterUpdater('alignerTable'),
    updateDashNewLeadsTable: createFilterUpdater('dashNewContact'),
    updateDashNewLeadsWidgetTable: createFilterUpdater('dashNewContactForWidget'),
    updateNewTable: createFilterUpdater('newContact'),
    updateBookedTable: createFilterUpdater('bookedContact'),
    updateFailedToAttendTable: createFilterUpdater('failedToAttendContact'),
    updateClosedTable: createFilterUpdater('closedContact'),
    updateAttendTable: createFilterUpdater('attendContact'),
    updateClincheckTable: createFilterUpdater('clincheckContact'),
    updateAttendedChecklistsTable: createFilterUpdater('attendedChecklistsContact'),
    updateTreatmentStartedTable: createFilterUpdater('treatmentStarted'),
    updateArchiveTable: createFilterUpdater('archivedContact'),
};
